import { authConstants, messageConstants, dashboardConstants, schoolConstants } from "_constants";

const initialState = {
	isFetching: false,
	submitMessageSuccess: false,
	updateMessageSuccess: false,
	deleteMessageSuccess: false,
	importMsgList: [],
	message: {},
	readmessage: {},
	submitBatchMessageSuccess: false,
	navigationObject: {
		root: {
			searchKey: "",
			searchWord: "",
			sortingKey: "lastUpdateTime",
			sortingDirection: "DESC",
			msgList: [],
			numOfPage: 1,
			currentPage: 1,
			totalItems: 0,
		},
		dashboard: {
			dateRange: "",
			level: "",
			msgList: [],
			numOfPage: 1,
			currentPage: 1,
			totalItems: 0,
		},
		school: {
			sortingKey: "lastUpdateTime",
			sortingDirection: "DESC",
			msgList: [],
			numOfPage: 1,
			currentPage: 1,
			totalItems: 0,
		},
	},
};

const messageReducer = (state = initialState, action) => {
	switch (action.type) {
		case authConstants.type.UNAUTHORIZED_ERROR: {
			let navigationObject = initialState.navigationObject;
			if (typeof state.navigationObject?.root != "undefined") {
				navigationObject = {
					...state.navigationObject,
					root: { ...state.navigationObject?.root, currentPage: 1 },
				};
			}
			if (typeof state.navigationObject?.dashboard != "undefined") {
				navigationObject = {
					...state.navigationObject,
					dashboard: { ...state.navigationObject?.dashboard, currentPage: 1 },
				};
			}
			if (typeof state.navigationObject?.school != "undefined") {
				navigationObject = {
					...state.navigationObject,
					school: { ...state.navigationObject?.school, currentPage: 1 },
				};
			}
			return {
				...state,
				navigationObject: navigationObject,
			};
		}
		case messageConstants.type.SUBMIT_BATCH_MSG_REQUEST: {
			return {
				...state,

				submitBatchMessageSuccess: false,
			};
		}
		case messageConstants.type.SUBMIT_BATCH_MSG_FAILURE: {
			return {
				...state,
				submitBatchMessageSuccess: false,
			};
		}
		case messageConstants.type.SUBMIT_BATCH_MSG_SUCCESS: {
			return {
				...state,
				submitBatchMessageSuccess: true,
				importMsgList: [],
			};
		}
		case messageConstants.type.SUBMIT_MSG_REQUEST: {
			return {
				...state,
				isFetching: true,
				submitMessageSuccess: false,
			};
		}
		case messageConstants.type.SUBMIT_MSG_FAILURE: {
			return {
				...state,
				isFetching: false,
				submitMessageSuccess: false,
			};
		}
		case messageConstants.type.SUBMIT_MSG_SUCCESS: {
			return {
				...state,
				isFetching: false,
				submitMessageSuccess: true,
			};
		}
		case messageConstants.type.RESET_MSG_SUCCESS: {
			return {
				...state,
				submitMessageSuccess: false,
				updateMessageSuccess: false,
				deleteMessageSuccess: false,
				submitBatchMessageSuccess: false,
			};
		}
		case messageConstants.type.FETCH_MSG_LIST_SUCCESS: {
			if (action.navigationKey) {
				let navigationObject = {
					msgList: action.msgList,
					numOfPage: action.totalPage,
					currentPage: action.currentPage,
					totalItems: action.totalNum,
				};
				if (action.searchKey) {
					navigationObject = { ...navigationObject, searchKey: action.searchKey };
				}
				if (action.searchWord) {
					navigationObject = { ...navigationObject, searchWord: action.searchWord };
				}
				if (action.sortingKey) {
					navigationObject = { ...navigationObject, sortingKey: action.sortingKey };
				}
				if (action.sortingDirection) {
					navigationObject = { ...navigationObject, sortingDirection: action.sortingDirection };
				}
				if (action.level) {
					navigationObject = { ...navigationObject, level: action.level };
				}
				if (action.dateRange) {
					navigationObject = { ...navigationObject, dateRange: action.dateRange };
				}
				return {
					...state,
					navigationObject: {
						...state.navigationObject,
						[`${action.navigationKey}`]: {
							...navigationObject,
						},
					},
				};
			} else {
				return state;
			}
		}
		case dashboardConstants.type.DASHBOARD_SET_MESSAGE_FILTER: {
			return {
				...state,
				navigationObject: {
					...state.navigationObject,
					dashboard: {
						dateRange: action.dateRange || "",
						level: action.level || "",
					},
				},
			};
		}
		case schoolConstants.type.FETCH_SCHOOL_SUCCESS: {
			if (action.navigationKey) {
				let navigationObject = {
					msgList: action.msgList,
					numOfPage: action.totalPage,
					currentPage: action.currentPage,
					totalItems: action.totalNum,
				};
				if (action.sortingKey) {
					navigationObject = { ...navigationObject, sortingKey: action.sortingKey };
				}
				if (action.sortingDirection) {
					navigationObject = { ...navigationObject, sortingDirection: action.sortingDirection };
				}
				return {
					...state,
					isFetching: false,

					navigationObject: {
						...state.navigationObject,
						[`${action.navigationKey}`]: {
							...navigationObject,
						},
					},
				};
			} else {
				return state;
			}
		}
		case messageConstants.type.IMPORT_MSG_LIST: {
			return {
				...state,
				importMsgList: action.importMsgList,
				submitBatchMessageSuccess: false,
			};
		}

		case messageConstants.type.FETCH_MSG_REQUEST: {
			return {
				...state,
				isFetching: true,
				message: {},
			};
		}
		case messageConstants.type.FETCH_MSG_FAILURE: {
			return {
				...state,
				isFetching: false,
			};
		}
		case messageConstants.type.FETCH_MSG_SUCCESS: {
			return {
				...state,
				isFetching: false,
				message: action.message,
			};
		}
		case messageConstants.type.FETCH_READ_MESSAGE: {
			return {
				...state,
				readmessage: action.message,
			};
		}
		case messageConstants.type.UPDATE_MSG_REQUEST: {
			return {
				...state,
				isFetching: true,
				updateMessageSuccess: false,
			};
		}
		case messageConstants.type.UPDATE_MSG_FAILURE: {
			return {
				...state,
				isFetching: false,
				updateMessageSuccess: false,
			};
		}
		case messageConstants.type.UPDATE_MSG_SUCCESS: {
			return {
				...state,
				isFetching: false,
				updateMessageSuccess: true,
			};
		}
		case messageConstants.type.DELETE_MSG_REQUEST: {
			return {
				...state,
				deleteMessageSuccess: false,
			};
		}
		case messageConstants.type.DELETE_MSG_FAILURE: {
			return {
				...state,
				deleteMessageSuccess: false,
			};
		}
		case messageConstants.type.DELETE_MSG_SUCCESS: {
			return {
				...state,
				deleteMessageSuccess: true,
			};
		}
		default: {
			return state;
		}
	}
};

export default messageReducer;
